import { render, staticRenderFns } from "./ProductLinksSection.vue?vue&type=template&id=a7f207a4&scoped=true&"
import script from "./ProductLinksSection.vue?vue&type=script&lang=js&"
export * from "./ProductLinksSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductLinksSection.vue?vue&type=style&index=0&id=a7f207a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f207a4",
  null
  
)

export default component.exports